import { AlertLevel } from './alert-level.model';

export class Alert {
  level: AlertLevel;
  message: string;
}
